import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AlertController, IonContent, IonSlides, LoadingController, ModalController, NavController, Platform } from '@ionic/angular';
import { SubscriptionListenerComponent } from '../../angular-wallet-base/SubscriptionListenerComponent';
import { Store } from '@ngrx/store';
import { AppState } from '../../angular-wallet-base/store/appState';
import { TranslateService } from '@ngx-translate/core';
import { TokenDefinitionService } from '../../angular-wallet-base/services/token-definition.service';
import { TransactionSenderService } from '../../angular-wallet-base/services/transaction-sender.service';
import { MembersPortalService } from '../../angular-wallet-base/services/members-portal.service';
import { NetworkService } from '../../angular-wallet-base/services/network.service';
import { WireDetails } from '../../angular-wallet-base/wire-details';
import { ClipboardService } from 'ngx-clipboard';
import { Clipboard } from '@ionic-native/clipboard/ngx';
import { handleCopy } from 'src/app/angular-wallet-base/utils';
import { WireTransferService } from 'src/app/angular-wallet-base/services/wire-transfer.service';
import { EpinClaimSuccessComponent } from '../epin-claim-success/epin-claim-success.component';
import { AppModeService } from '../../angular-wallet-base/services/app-mode.service';

@Component({
  selector: 'wire-transfer-modal-token',
  templateUrl: './wire-transfer-modal.component.html',
  styleUrls: ['./wire-transfer-modal.component.scss'],
})
export class WireTransferModalComponent extends SubscriptionListenerComponent implements OnInit {
  @Input() public wireDetail: WireDetails = null;
  @Input() public quoteId;
  @Input() public tokenSymbol;
  @Input() public tokenGuid;
  @Input() public baseChainSymbol;
  @Input() public currency;
  public loadingDelivery = false;
  public isDesktopMode;
  public bankInfoCopied: boolean = false;
  constructor(private activatedRoute: ActivatedRoute,
              protected store: Store<AppState>,
              private nav: NavController,
              private alertController: AlertController,
              private translate: TranslateService,
              private transactionSender: TransactionSenderService,
              private loadingController: LoadingController,
              private modal: ModalController,
              private clipboard: Clipboard,
              private clipboardService: ClipboardService,
              private platform: Platform,
              private appMode: AppModeService,
              private wireTransferService: WireTransferService,
              private networkManager: NetworkService,
              private elementRef: ElementRef) {
    super(store);
    this.appMode.isDesktopMode.subscribe(mode => this.isDesktopMode = mode);
  }

  async ngOnInit() {
  }

  async purchase () {   
    this.loadingDelivery=true;
    let temp=await this.wireTransferService.confirmTransaction(this.quoteId);
    this.loadingDelivery=false;
    this.modal.dismiss(this.wireDetail);
  }

  dismiss () {
    this.modal.dismiss();
  }

  async copyBankDetails()
  {
    let bankDetails="";
    let popupMessage= await this.translate.get('bank_account.copy_wire').toPromise();
    if(this.wireDetail)
    {
      bankDetails+="Quote Id:"+this.quoteId+"\n\n";
      bankDetails+="Beneficiary Bank:"+this.wireDetail.beneficiaryName+"\n\n";
      bankDetails+="Swift Code:"+this.wireDetail.swiftCode+"\n\n";
      if(this.wireDetail.intermediaryBank)
      {
        bankDetails+="Intermediary Bank:"+this.wireDetail.intermediaryBank+"\n\n";
      }
      if(this.wireDetail.iSwiftCode)
      {
        bankDetails+="Is Swift Code:"+this.wireDetail.iSwiftCode+"\n\n";
      }
      if(this.wireDetail.ABA)
      {
        bankDetails+="ABA:"+this.wireDetail.ABA+"\n\n";
      }
      bankDetails+="Beneficiary Name:"+this.wireDetail.beneficiaryName+"\n\n";
      bankDetails+="Beneficiary Address:"+this.wireDetail.beneficiaryAddress+"\n\n";
      bankDetails+="Account No:"+this.wireDetail.accountNo+"\n\n";
      if(this.wireDetail.iBan)
      {
        bankDetails+="IBAN:"+this.wireDetail.iBan+"\n\n";
      }
      bankDetails+="Reference Field (Message to Beneficiary Bank) / For Further Credit to:"+this.wireDetail.referenceField+"\n\n";
    }
    await handleCopy(bankDetails, this.platform, this.clipboard, this.alertController, this.translate, this.clipboardService, popupMessage);
  }
}
